import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M5.99902 0.5C7.45737 0.501602 8.85551 1.08208 9.88672 2.11328C10.8534 3.07996 11.4243 '
  + '4.36864 11.4932 5.72754L11.5 6.00098C11.4998 7.08841 11.1774 8.15148 10.5732 9.05566C9.96889 '
  + '9.96013 9.10949 10.6648 8.10449 11.0811C7.09953 11.4973 5.99361 11.6067 4.92676 11.3945C3.85994 '
  + '11.1823 2.88047 10.6578 2.11133 9.88867C1.34219 9.11953 0.817713 8.14006 0.605469 7.07324C0.393259 '
  + '6.00639 0.502708 4.90047 0.918945 3.89551C1.33523 2.89051 2.03987 2.03111 2.94434 1.42676C3.84852 '
  + '0.822614 4.91159 0.500193 5.99902 0.5ZM5.7002 1.90039C5.32898 1.90039 4.97249 2.04714 4.70996 '
  + '2.30957C4.44746 2.57208 4.29986 2.92857 4.2998 3.2998C4.2998 3.5767 4.3823 3.8479 4.53613 '
  + '4.07812C4.59103 4.16023 4.65448 4.23556 4.72461 4.30371C4.46053 4.32186 4.21087 4.43376 4.02246 '
  + '4.62207C3.81617 4.82836 3.7002 5.10865 3.7002 5.40039C3.7003 5.69199 3.81626 5.97154 4.02246 '
  + '6.17773C4.22869 6.38392 4.50818 6.49995 4.7998 6.5H4.90039V7.2998H4.7998C4.50823 7.29986 4.22869 '
  + '7.41595 4.02246 7.62207C3.81617 7.82836 3.7002 8.10865 3.7002 8.40039C3.7003 8.69199 3.81626 '
  + '8.97154 4.02246 9.17773C4.2287 9.38392 4.50818 9.49995 4.7998 9.5H7.2002C7.49182 9.49995 7.7713 '
  + '9.38392 7.97754 9.17773C8.18374 8.97154 8.2997 8.69199 8.2998 8.40039C8.2998 8.10865 8.18383 '
  + '7.82836 7.97754 7.62207C7.77131 7.41595 7.49177 7.29986 7.2002 7.2998H7.09961V5.40039C7.09961 '
  + '5.10865 6.98363 4.82836 6.77734 4.62207C6.70103 4.54582 6.61478 4.48188 6.52148 4.43164C6.58074 '
  + '4.38863 6.63821 4.34226 6.69043 4.29004C6.8861 4.0943 7.01923 3.84469 7.07324 3.57324C7.12724 '
  + '3.30176 7.09904 3.0204 6.99316 2.76465C6.8872 2.50883 6.70777 2.28958 6.47754 2.13574C6.24742 '
  + '1.98206 5.97691 1.90043 5.7002 1.90039Z'

const InfoCircleIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH} fill="currentColor" stroke="currentColor" />
  </svg>
)

InfoCircleIcon.propTypes = {
  className: PropTypes.string
}

InfoCircleIcon.defaultProps = {
  className: 'tw:h-3 tw:w-3'
}

export default InfoCircleIcon
